var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94622 2.94712C4.57367 3.31967 4.57367 3.92149 4.94622 4.29404L8.65263 8.00044L4.94622 11.7068C4.57367 12.0794 4.57367 12.6812 4.94622 13.0538C5.31877 13.4263 5.92059 13.4263 6.29314 13.0538L10.6778 8.66912C11.0503 8.29657 11.0503 7.69476 10.6778 7.32221L6.29314 2.93757C5.93014 2.57457 5.31877 2.57457 4.94622 2.94712Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhite);
export default __webpack_public_path__ + "static/media/Chevron White.20528f205926ddbbcae14676b6ba68d8.svg";
export { ForwardRef as ReactComponent };